module.exports = __webpack_public_path__ + "img/calendar.f8fcc13b.svg";